<template>
  <router-view />
</template>
<script>
  export default {
    name: 'CategoriaModule',
  }
</script>
